const ColorPallete = {
  green: "green",
  gray: "gray",
  red: "#ff4500",
  white: "#fff",
};

export default ColorPallete;
